'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '4px 8px',
    cursor: 'pointer',
    color: _colors2.default.primaryText,
    position: 'relative',

    ':hover': {
      color: _colors2.default.theme
    }
  },
  input: {
    opacity: 0,
    zIndex: -999,
    position: 'absolute'
  },
  label: {
    color: _colors2.default.secondaryText,
    transition: 'all .3s ease-in-out',
    lineHeight: '24px',
    fontSize: '16px',
    fontWeight: 'bolder',
    borderBottom: '2px solid transparent'
  },
  icon: {
    width: '24px',
    height: '24px',
    marginRight: '8px'
  },
  unchecked: {
    width: '18px',
    height: '18px',
    border: '2px solid ' + _colors2.default.icons,
    boxSizing: 'border-box',
    borderRadius: '2px',
    margin: '3px'
  }
};
module.exports = exports.default;